import React from "react";
import "./displayHeading.css";

function DisplayHeading({ doSomething, title, buttonName }) {
  return (
    <div className="container title-container">
        <p className="title">{title}</p>
        {title && <button className={'btn edit-btn ' + (!buttonName && 'hidden')} onClick={() => doSomething()}>{buttonName}</button>}
    </div>
  )
}

export default DisplayHeading;